__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/7824c8336e856d2c8f81bd86a003714d3a8739ab7c7c14ad4dc26fa9/";